var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("remote-select", {
    attrs: {
      "associate-data": _vm.state.associateData,
      "remote-method": _vm.debounce(_vm.filterMethod, 1000),
      loading: _vm.state.loading,
      placeholder: _vm.placeholder,
      disabled: _vm.disabled,
    },
    on: { changed: _vm.change },
    model: {
      value: _vm.model,
      callback: function ($$v) {
        _vm.model = $$v
      },
      expression: "model",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }